{
  "rating-star-icon": {
    "text": {
      "review": "đánh giá",
      "reviews": "đánh giá"
    }
  }
}
